/* global axios */

import ApiClient from './ApiClient';

class ConversationVisibilityScopes extends ApiClient {
  constructor() {
    super('conversation_visibility_scopes', { accountScoped: true });
  }

  updateForUser(userId, data) {
    return axios.patch(`${this.url}/${userId}`, {
      conversation_visibility_scope: data,
    });
  }
}

export default new ConversationVisibilityScopes();
